import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState: IRackManagerState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null
};

export const rackManagerSlice = createSlice({
    name: 'rackManager',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceRackManager: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addRackManager: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateRackManager: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
              state.data[localID] = data;
            }
            state.details = data;
          },
        deleteRackManager: (state, action) => {
            const rackManagerToRemove: IRackManager = action.payload.data;
            const newRackManagerData = state.data && state.data.filter(
                (rackManager: IRackManager) => {
                    return (
                        rackManager.id !== rackManagerToRemove.id
                    );
                }
            );
            state.data = newRackManagerData;
            state.totalCount = state.totalCount - 1;
        },
        setRackManagerDetails: (state, action) => {
            state.details = action.payload.data;
        }
    },
});

export const rackManagerActions = rackManagerSlice.actions;

export default rackManagerSlice.reducer;
